import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressDto } from 'src/app/domain/models/dto/address.dto';
import { UserDto } from 'src/app/domain/models/dto/user.dto';
import { PersonDto } from 'src/app/domain/models/dto/person.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private readonly http: HttpClient) { }

    get(userCode: string): Observable<ResponseObjectModel<UserDto>> {
        return this.http.get<ResponseObjectModel<UserDto>>(`${environment.API_BASE_URL}/v1/users/${userCode}`);
    }

    updateTuneTransaction(transactionId: string) {
        return this.http.put<ResponseObjectModel<UserDto>>(`${environment.API_BASE_URL}/v1/users/tracking/${transactionId}`, null);
    }

    updateTuneAffiliate(affiliateId: string) {
        return this.http.put<ResponseObjectModel<UserDto>>(`${environment.API_BASE_URL}/v1/users/affiliate/${affiliateId}`, null);
    }

    getPeople(userCode: string): Observable<ResponseObjectModel<PersonDto>> {
        return this.http.get<ResponseObjectModel<PersonDto>>(`${environment.API_BASE_URL}/v1/people/users/${userCode}`);
    }
}
